export var ArticleAlternativeContentNumber;
(function (ArticleAlternativeContentNumber) {
    ArticleAlternativeContentNumber[ArticleAlternativeContentNumber["VERSION_A"] = -1] = "VERSION_A";
    ArticleAlternativeContentNumber[ArticleAlternativeContentNumber["VERSION_B"] = 0] = "VERSION_B";
})(ArticleAlternativeContentNumber || (ArticleAlternativeContentNumber = {}));
//# sourceMappingURL=article-alternative-content.js.map